import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ServiceChangeRequestReview } from './service-change-request-review.model';
import * as ServiceChangeRequestReviewActions from './service-change-request-review.actions';

export const serviceChangeRequestReviewsFeatureKey = 'serviceChangeRequestReviews';

export interface State extends EntityState<ServiceChangeRequestReview> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceChangeRequestReview> = createEntityAdapter<ServiceChangeRequestReview>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceChangeRequestReviewActions.addServiceChangeRequestReview,
    (state, action) => adapter.addOne(action.serviceChangeRequestReview, state)
  ),
  on(ServiceChangeRequestReviewActions.upsertServiceChangeRequestReview,
    (state, action) => adapter.upsertOne(action.serviceChangeRequestReview, state)
  ),
  on(ServiceChangeRequestReviewActions.addServiceChangeRequestReviews,
    (state, action) => adapter.addMany(action.serviceChangeRequestReviews, state)
  ),
  on(ServiceChangeRequestReviewActions.upsertServiceChangeRequestReviews,
    (state, action) => adapter.upsertMany(action.serviceChangeRequestReviews, state)
  ),
  on(ServiceChangeRequestReviewActions.updateServiceChangeRequestReview,
    (state, action) => adapter.updateOne(action.serviceChangeRequestReview, state)
  ),
  on(ServiceChangeRequestReviewActions.updateServiceChangeRequestReviews,
    (state, action) => adapter.updateMany(action.serviceChangeRequestReviews, state)
  ),
  on(ServiceChangeRequestReviewActions.deleteServiceChangeRequestReview,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceChangeRequestReviewActions.deleteServiceChangeRequestReviews,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceChangeRequestReviewActions.loadServiceChangeRequestReviews,
    (state, action) => adapter.setAll(action.serviceChangeRequestReviews, state)
  ),
  on(ServiceChangeRequestReviewActions.clearServiceChangeRequestReviews,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
